import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { unblockBookingCustomerMutation } from "@/app/Bookings/GraphQL/blocklistMutations";
import { toast } from "sonner";

export function useUnblockCustomer() {
  const { mutateAsync, isPending } = useGqlMutation(
    unblockBookingCustomerMutation,
  );

  const unblockCustomer = async (bookingId: string) => {
    try {
      await mutateAsync({
        booking_id: bookingId,
      });
      toast.success("Customer unblocked");
    } catch (error) {
      toast.error("Failed to unblock customer");
      throw error;
    }
  };

  return {
    unblockCustomer,
    isUnblocking: isPending,
  };
}
